import styled from "styled-components";

export const HiveBackWrapper = styled.div`
    min-height: 52px;
    display: flex;
    gap: 6px;
    margin-left: 24px;
    align-items: center;

    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    
    svg {
        width: 24px;
        height: 24px;
    }
`